import { whiteLabelingConfig } from '@/utils/whiteLabeling';
import { THEMES } from '@/utils/whiteLabeling/whiteLabelingConfig';

const DOC_RMR = 'https://docs.elevateaccounts.com/docs/rmr/HSA_Beneficiary_Form.pdf';
const DOC_GUSTO = 'https://docs.elevateaccounts.com/docs/gusto/HSA_Beneficiary_Form.pdf';
const DOC_ELEVATE = 'https://docs.elevateaccounts.com/docs/HSA_Beneficiary_Form.pdf';

const useGetBeneficiaryPaperFormLink = () => {
  if (whiteLabelingConfig.key === THEMES.rmr) return DOC_RMR;
  if (whiteLabelingConfig.key === THEMES.gusto) return DOC_GUSTO;
  return DOC_ELEVATE;
};

export default useGetBeneficiaryPaperFormLink;
